module.exports = __webpack_public_path__ + "media/img/help_center/Institution_User_Settings_01-6901bfb383403ab7e763b1742a43df31.jpg";